import React from "react";
import styles from "./icon.module.scss";
const LightweightIcon = ({ className = "", icon, color = "primary" }) => {
    const getSpriteLink = (icon) => {
        let path = "assets/icon-sprite/symbol/svg/";
        let spriteFileName = "sprite.symbol.svg";
        if (window.UIKit && UIKit.svgSprite) {
            const svgSprite = UIKit.svgSprite;
            if (svgSprite.fullPath != null) {
                return `${svgSprite.fullPath}#${icon}`;
            }
            if (svgSprite.path != null) {
                path = svgSprite.path;
            }
            if (svgSprite.fileName != null) {
                spriteFileName = svgSprite.fileName;
            }
        }
        return `${path}${spriteFileName}#${icon}`;
    };
    let colorClass = styles.colorPrimary;
    if (color.toLowerCase() !== "primary") {
        colorClass = styles.colorSecondary;
    }
    return (React.createElement("div", { className: `${className} ${styles.vhvIcon}` },
        React.createElement("svg", { className: colorClass },
            React.createElement("use", { xlinkHref: getSpriteLink(icon) }))));
};
export default LightweightIcon;
